import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationDialog } from '../../..';

const UNLOCK_DURATION_MS = 5000;

interface Props {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const CountdownBar: FC<{ durationMs: number }> = ({ durationMs }) => {
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setStarted(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="mb-1 h-1 w-full overflow-hidden rounded bg-grey-200">
      <div
        className="h-full w-full origin-left bg-primary-main"
        style={{
          transform: started ? 'scaleX(0)' : 'scaleX(1)',
          transition: `transform ${durationMs}ms linear`
        }}
      />
    </div>
  );
};

export const GocardlessInvoiceDialog: FC<Props> = ({ open, onConfirm, onClose }) => {
  const { t } = useTranslation();
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    if (!open) return;

    const timeout = setTimeout(() => setUnlocked(true), UNLOCK_DURATION_MS);
    return () => {
      clearTimeout(timeout);
      setUnlocked(false);
    };
  }, [open]);

  return (
    <ConfirmationDialog
      open={open}
      variant="warning"
      width="500px"
      title={t('company:PAYMENT_VIEW_GOCARDLESS_TITLE')}
      contentText={t('company:PAYMENT_VIEW_GOCARDLESS_HINT')}
      confirmButtonText={t('company:PAYMENT_VIEW_GOCARDLESS_CONFIRM')}
      confirmButtonDisabled={!unlocked}
      cancelButtonText={t('common:CLOSE')}
      onConfirm={onConfirm}
      onClose={onClose}
      onCancel={onClose}
      contentComponent={unlocked ? undefined : <CountdownBar durationMs={UNLOCK_DURATION_MS} />}
    />
  );
};
